import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { renderFormattedText } from "Lib/text-utils";
import styles from "Styles/CompanySize.module.css";

const MarketingCapabilitiesInfoContent = ({ heading }) => {
  return (
    <InfoContentMotionWrapper>
      <h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
      <div className={styles.decorativeElements}>
        <svg
          style={{ marginTop: "87px", marginLeft: "-50px" }}
          xmlns="http://www.w3.org/2000/svg"
          width="193"
          height="194"
          viewBox="0 0 193 194"
          fill="none"
        >
          <path
            d="M150.486 150.366L175.851 151.797L165.614 128.526L189.98 121.179L172.406 102.847L192.827 87.6019L170.03 76.428L184.035 55.1249L158.767 52.4437L164.681 27.6525L139.995 33.8011L137.092 8.51015L115.954 22.7408L104.599 -6.97261e-05L89.5626 20.5962L71.1112 3.15194L63.9991 27.6328L40.6815 17.5908L42.3412 42.9954L16.9697 41.5604L27.2059 64.831L2.83995 72.1779L20.4143 90.5103L-0.000438571 105.759L22.7971 116.933L8.79155 138.236L34.0534 140.913L28.1456 165.709L52.8321 159.56L55.7349 184.851L76.8661 170.616L88.2279 193.361L103.258 172.761L121.709 190.205L128.828 165.728L152.146 175.77L150.486 150.366Z"
            fill="#FCCA23"
          />
        </svg>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingCapabilitiesInfoContent;
